import { DataFetch } from "./apiFetching/cocktaildataFetch";

function App() {
  return (
    <div>
      <DataFetch />
    </div>
  );
}

export default App;
